import FJClothesChangerLeft from './FJClothesChangerLeft';
import { useDispatch, useSelector } from 'react-redux';
import useLocalStore from '../../../hooks/useLocalStore';
import FJActionClothesChanger from '../../../redux/action/FJActionClothesChanger';
import { useCallback } from 'react';
import FJUtil from '../../../util/FJUtil';
import FJActionCommon from '../../../redux/action/FJActionCommon';
import FJActionEditPage from '../../../redux/action/FJActionEditPage.js';
const FJClothesChangerLeftContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();

    const peopleImageInfo = useSelector(state => state.clothesChanger.peopleImageInfo);
    const clothesImageInfo = useSelector(state => state.clothesChanger.clothesImageInfo);
    const selectedName = useSelector(state => state.clothesChanger.selectedStyle);
    const taskStatus = useSelector(state => state.common.taskStatus);
    const creditNumber = useSelector(state => state.common.creditNumber);
    const freeNumCreation = useSelector(state => state.common.freeNumCreation);
    const isProjectLoading = useSelector(state => state.common.isProjectLoading);
    // 选中衣服
    const _onSelectClothes = useCallback(
        (name, url, applyDoneCallback) => {
            dispatch(FJActionClothesChanger.selectClothesAction(name, url, applyDoneCallback));
        },
        [dispatch],
    );
    const _onGenerate = useCallback(() => {
        if (FJUtil.isGeneratingStatus(taskStatus)) return;
        dispatch(FJActionClothesChanger.generateAction());
        dispatch(FJActionCommon.setHeaderTabIndexAction(0));
    }, [dispatch, taskStatus]);

    const _onUploadImage = useCallback(
        (file, isClothesImage) => {
            dispatch(FJActionClothesChanger.uploadImageAction(file, isClothesImage));
        },
        [dispatch],
    );
    const _openMediaLibrary = useCallback(
        target => {
            window.mediaLibraryOptions = { target: target };
            dispatch(FJActionEditPage.openMediaLibraryAction());
        },
        [dispatch],
    );

    return (
        <FJClothesChangerLeft
            openMediaLibrary={_openMediaLibrary}
            creditNumber={creditNumber}
            taskStatus={taskStatus}
            onGenerate={_onGenerate}
            freeNumCreation={freeNumCreation}
            peopleImageInfo={peopleImageInfo}
            clothesImageInfo={clothesImageInfo}
            onSelectClothes={_onSelectClothes}
            onUploadImage={_onUploadImage}
            isProjectLoading={isProjectLoading}
            selectedName={selectedName}
        />
    );
};
export default FJClothesChangerLeftContainer;
